module.exports = __webpack_public_path__ + "static/media/IMG_0064.84573e5b.jpg";